import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { Modal } from 'antd';
import '../index.scss';
import { hideLoader, showLoader } from '../../../utils/loader';
import { customBaseUrl, httpPost } from '../../../services/http';

const DeactivateBulkUser = ({ showModal, hideModal, title, className }) => {
  const [file, setFile] = useState('');


  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader();

    const formdata = new FormData();
    formdata.append('file', file);

    const res = await httpPost(
      `/api/v1/admin/bulk/account-deactivation`,
      formdata, customBaseUrl.authUrl
    );

    if (res.status) {
      hideLoader();
      Swal.fire('Done', res.message, 'success');
      setFile('');
      hideModal(false);
    } else {
      Swal.fire('Error', res.message, 'error');
    }
  };

  return (
    <Modal
      className={className}
      title={title}
      centered
      visible={showModal}
      onOk={() => hideModal(false)}
      onCancel={() => hideModal(false)}
      width={600}
      footer={0}
    >
      <form class='row g-3 needs-validation' novalidate>
        
        <div className='col-10 mt-5 mb-3 mx-auto'>
        <label for='validationCustom04' class='form-label'>
            Select File
          </label>
          <div class='input-group'>
            <input
              type='file'
              class='form-control'
              id='inputGroupFile02'
              onChange={(e) => setFile(e.target.files[0])}
            />
            <label class='input-group-text' for='inputGroupFile02'>
              Browse
            </label>
            <div class='invalid-feedback'>File is required.</div>
          </div>
        </div>

        <div class='col-12 text-center mt-5'>
          <button class='btn btn-primary' type='submit' onClick={handleSubmit}>
            Submit form
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default DeactivateBulkUser;
